// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2wylm","trigger":"_2y4rg","content":"_2sqJd"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Tether/Tether.css
// module id = 490
// module chunks = 0